/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {squareApiProxy} from '../api'

export const useMutationSquareApiProxy = createReactQueryMutationHook('squareApiProxy', squareApiProxy)
